import { sfx } from "@/game/audioEngine";

export default function PixelButton({
  children,
  variant = "primary",
  className = "",
  onClick,
  disabled,
  type = "button",
  withSound = true,
  ...rest
}) {
  const variants = {
    primary: "pixel-btn",
    secondary: "pixel-btn pixel-btn-secondary",
    dark: "pixel-btn pixel-btn-dark",
    ghost: "pixel-btn pixel-btn-ghost",
  };
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={(e) => {
        if (withSound) sfx.click();
        if (onClick) onClick(e);
      }}
      className={`${variants[variant] || variants.primary} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
